import React from "react";

const Index = () => {
  return (
    <div data-aos="fade-left" className="bg-[#f8f9fa] w-full py-16 px-12 mt-24">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start gap-10">
        {/* Left Content */}
        <div className="md:w-1/2">
          <h3 className="text-[#f5c956] font-bold text-sm uppercase tracking-wide">
            Our Story
          </h3>
          <h2 className="text-black font-extrabold text-3xl md:text-4xl leading-tight">
            What Is NKENNEAi?
          </h2>
        </div>

        {/* Right Content */}
        <div className="md:w-1/2 space-y-6">
          <p className="text-gray-700 text-base leading-relaxed border-b border-[#dfdddd] pb-4">
            Language is more than just a tool for communication—it shapes
            identity, culture, and connection. Africa, with its rich diversity
            of over 2,000 languages, holds a vast linguistic heritage. Yet,
            these languages have often been left behind in the digital age,
            making communication difficult, both within the continent and the
            wider world. NKENNEAi was founded to bridge this gap, starting as a
            language learning app and expanding into a AI-powered translation
            platform.
          </p>

          <p className="text-gray-700 text-base leading-relaxed border-b border-[#dfdddd] pb-4">
            Today, NKENNEAi offers powerful AI tools for translating African
            languages in both text and speech. Our platform ensures translations
            are accurate, appropriate, and context-aware. We provide
            easy-to-integrate APIs, allowing developers to add translation,
            text-to-speech, and speech-to-text features to their applications.
            These tools help businesses, educators, and innovators create more
            inclusive and language-friendly digital experiences.
          </p>

          <p className="text-gray-700 text-base leading-relaxed border-b border-[#dfdddd] pb-4">
            At NKENNEAi, we are dedicated to improving access to African
            languages in the digital world. By making our tools accurate,
            accessible, and easy to use, we aim to help all African languages
            thrive and be celebrated online.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
